/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const ScaledHeightImage = (props) => {

    const image = props?.image;
    const settings = props?.settings;
    const orientation = props?.orientation;
    const width = image?.width;
    const height = image?.height;
    const url = image?.url;
    const alt = image?.height;
    const options = settings?.options;
    const dimension = options?.dimension ?? "100%";
    const forceSixteenNine = options?.forceSixteenNine ?? false;
    const contain  = options?.contain ?? false;
    const hasWidth = !!width;
    const hasHeight = !!height;

    let aspect_ratio, fit, maxWidth;
    if (forceSixteenNine) {
        aspect_ratio = "16/9";
        // fit = 'cover'
        fit = "contain";
        maxWidth = "100%";
    } else if (contain) {
        fit = "contain";
        maxWidth = "100%";
    } else if (hasWidth && hasHeight) {
        fit = orientation === "vertical" ? "contain" : undefined;
        maxWidth = "100%";
        const longerSide = height >= width ? "height" : "width";
        aspect_ratio = (longerSide === "height") ? `${height}/${width}` : `${width}/${height}`;
    }

    return (
        <>
            {image &&
                <>
                    <img
                        src={url}
                        alt={alt}
                        height={dimension}
                        style={{
                            aspectRatio: aspect_ratio,
                            objectFit: fit,
                            maxWidth: maxWidth,
                        }}
                    />
                </>
            }
        </>
    );
};

export { ScaledHeightImage };
